<template>
  <form class="integration-form card-body"
        :class="{ 'integration-form_edit': isEdit }">
    <button v-if="step > 1"
            type="button"
            class="integration-form-return"
            @click="goBackOneStep">
      <i class="mdi mdi-arrow-left pointer"></i>
    </button>
    <v-stepper v-model="step"
               class="stepper"
               alt-labels>
      <v-stepper-header class="stepper-header">
        <v-stepper-step class="stepper-header-step"
                        :complete="step > 1"
                        step="1"
                        @click="selectStep(1)">
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="stepper-header-step"
                        :complete="step > 2"
                        step="2"
                        @click="selectStep(2)">
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step class="stepper-header-step"
                        :complete="step > 3"
                        step="3"
                        @click="selectStep(3)">
        </v-stepper-step>
      </v-stepper-header>

      <h1 class="text-center text-heading">
        <strong>
          {{ isEdit ? this.$t('message.integrations.message.editIntegration'): this.$t('message.integrations.message.newIntegration') }}
        </strong>
      </h1>
      <h4 class="text-muted text-center">
        {{$t('message.integrations.message.integrationRecord')}}
      </h4>

      <v-stepper-items>
        <v-stepper-content step="1">
          <v-text-field :label="$t('message.generics.message.name')"
                        name="Nome"
                        v-model="form.name"
                        v-validate="'required'"
                        :error-messages="errors.collect($t('message.generics.message.name'))"></v-text-field>
        </v-stepper-content>

        <v-stepper-content step="2">
          <card-select :options="typeOptions"
                       @selected="setType" />
        </v-stepper-content>

        <v-stepper-content step="3">
          <template v-if="step === 3">
            <template v-for="(field, index) in inputFields">
              <v-text-field v-if="field.defaultValue && !isEdit"
                            :key="index"
                            :label="field.label"
                            :name="field.label"
                            :value="field.defaultValue"                            
                            v-validate="field.required ? 'required' : undefined"
                            :error-messages="errors.collect(field.label)"
                            @input="setFieldValue(field.key, $event)">
              </v-text-field>
              <v-text-field v-else
                            :key="index"
                            :label="field.label"
                            :name="field.label"
                            v-model="configurations[field.key]"
                            v-validate="field.required ? 'required' : undefined"
                            :error-messages="errors.collect(field.label)">
              </v-text-field>
            </template>
            <v-text-field :label="$t('message.integrations.message.warningEmail')"
                          name="Email de aviso"
                          v-model="form.warningEmail"
                          :error-messages="errors.collect($t('message.integrations.message.warningEmail'))"></v-text-field>
            <template  v-for="(field, index) in radioFields">
              <div :key="'radioField-' + index" class="flex-col">
                <span><strong>{{ field.label }}:</strong></span>
                <radio-group                             
                            :name="field.label" 
                            :options="field.options"
                            :value="getRadioFieldValue(field)"
                            rules="required"
                            @input="setFieldValue(field.key, $event)"></radio-group>
              </div>

            </template>
            <v-checkbox v-if="hasAllowSaveClientDataField"
                        v-model="configurations['allowSaveClientData']"
                        :label="$t('message.integrations.message.allowSaveClientData')"></v-checkbox>
            <v-checkbox v-model="form.scheduleSend"
                        :label="$t('message.campaigns.message.sendIntegrationAfter')"></v-checkbox>
          </template>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <button type="button"
            class="btn btn-primary btn-round"
            @click="validate()">
      {{$t('message.generics.message.advance')}}
    </button>
  </form>

</template>

<script>
import CardSelect from "@components/form/CardSelect";
import vModel from "@mixins/v-model";
import EventBus from "@packages/event-bus";
import RadioGroup from "../../../../../components/form/RadioGroup.vue";
//import AppSelect from '@components/Select'

export default {
  components: {
    CardSelect,
    RadioGroup
  },
  computed: {
    isEdit() {
      return !!this.integration;
    },
    isSalesForceReturn() {
      return this.form.integrationType === "SALESFORCE" && !!this.code 
    },
    inputFields() {
      return this.typeFields.filter(field => !field.hidden && field.fieldType === 'INPUT')
    },
    radioFields() {
      return this.typeFields.filter(field => !field.hidden && field.fieldType === 'RADIO')
    }
  },

  props: {
    integration: {
      type: Object,
    },
    code: {
      type: String,
    },
  },

  data() {
    return {
      step: 1,
      form: {
        name: "",
        integrationType: undefined,
        warningEmail: undefined,
        scheduleSend: false,
      },
      configurations: {
        allowSaveClientData: false
      },
      id: undefined,
      typeOptions: [],
      typeFields: [],
      hasAllowSaveClientDataField: false
    };
  },

  watch: {
    integration: {
      deep: true,
      handler(val) {
        if (val) {
          this.setEditData();
        }
      },
    },
    step(val) {
      if(val === 2) {
        this.resetConfigurations()
      }
    }
  },

  methods: {

    selectStep(step) {
      if (this.isEdit) {
        this.step = step;
      }
    },
    setEditData(integration) {
      
      const editIntegration = integration || this.integration;

      this.id = editIntegration.id

      this.step = 3;
      this.form.name = editIntegration.name;
      this.form.integrationType = editIntegration.integrationType;
      this.form.warningEmail = editIntegration.warningEmail;
      this.form.scheduleSend = editIntegration.scheduleSend;

      this.getTypeFields(editIntegration.integrationType);

      this.configurations = JSON.parse(editIntegration.configurations);
    },
    goBackOneStep() {
      if (this.step > 1) {
        this.step -= 1;
      }
    },

    async getTypeFields(type) {
      try {
        const typeFields =
          await this.$api.integrationManagement.typeConfiguration({
            type,
          });

        const fields = Object.keys(typeFields).map((field) => {
          return {
            key: field,
            ...typeFields[field],
          };
        });

        this.checkIfHasAllowSaveClientDataField(fields)

        this.typeFields = fields;
       
      } catch (error) {
        console.log(error);
      }
    },

    async setType(type) {
      this.hasAllowSaveClientDataField = false
      this.form.integrationType = type;

      if (type === "RD_STATION") {
        const rdLoginUrl = await this.$api.externalIntegration.rdstation();

        localStorage.setItem(
          "integrationData",
          JSON.stringify({
            name: this.form.name,
            integrationType: this.form.integrationType,
            id: this.integration ? this.integration.id : undefined,
          })
        );

        location.href = rdLoginUrl;
      } else {
        await this.getTypeFields(type);
        this.typeFields.map(field => {
          if(field.defaultValue) {
            this.configurations[field.key] = field.defaultValue
          } 
          if(field.fieldType === "RADIO") {
            this.configurations[field.key] = field.options[0].value
          }
        })
        this.step++;
      }
    },
    reset() {
      this.form = {
        name: "",
        integrationType: undefined,
      };
      this.configurations = {};
      this.step = 1;
      this.$validator.reset();
    },

    async validate() {
      const isValid = await this.$validator.validateAll();

      if (isValid) {
        if (this.step < 2) {
          this.step++;
        } else {
          this.submitIntegration();
        }
      }
    },

    async submitIntegration() {
      try {
        EventBus.$emit("SHOW_SPINNER");

        if (!this.isEdit && !this.isSalesForceReturn) {
          const integration = await this.$api.integrationManagement.register({
            ...this.form,
            configurations: JSON.stringify(this.configurations),
          });

          if(this.form.integrationType === "SALESFORCE") {
            const salesForceUrl = await this.$api.externalIntegration.salesforce(integration.id);

            localStorage.setItem(
              "integrationData",
              JSON.stringify({
                name: this.form.name,
                integrationType: this.form.integrationType,
                id: integration.id,
              })
            );
           
            location.href = salesForceUrl;
          }

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t('message.successMessages.message.integrationRegistered'),
          });
          if(this.code) location.href = location.href.replace(/\?code=.*$/, '');
        } else {         
          await this.$api.integrationManagement.editIntegration({
            data: {
              ...this.form,
              configurations: JSON.stringify(this.configurations),
            },
            integrationId: this.isSalesForceReturn ? this.id : this.integration.id 
          });

          EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t('message.successMessages.message.integrationEdited'),
          });
          localStorage.removeItem("integrationData")
          if(this.code) location.href = location.href.replace(/\?code=.*$/, '');
        }

        this.$emit("registered");
      } catch (error) {
        console.log(error);
      } finally {
        EventBus.$emit("CANCEL_SPINNER");        
      }
    },

    async resetRdRegister() {
      const dataString = localStorage.getItem("integrationData");

      const data = JSON.parse(dataString);

      if (data.id) {
        let integration = await this.$api.integrationManagement.get(data.id);
        this.setEditData(integration);
      }

      this.form.name = data.name;
      this.form.integrationType = data.integrationType;

      this.getTypeFields(data.integrationType);

      this.configurations.code = this.code;

      this.step = 3;
      
      if(data.integrationType === "SALESFORCE") await this.submitIntegration()
    },

    checkIfHasAllowSaveClientDataField(array) {
      const allowSaveClientDataField = array.find(field => field.key === "allowSaveClientData")
      if(allowSaveClientDataField) this.hasAllowSaveClientDataField = true
    },

    setFieldValue(key, value) {
      this.configurations[key] = value
    },

    resetConfigurations() {
      this.configurations = {
        allowSaveClientData: false
      }
    },

    getRadioFieldValue(field) {
      if(this.isEdit) return this.configurations[field.key]
      return field.options[0].value
    },    
    
  },

  mixins: [vModel],

  async mounted() {
    const types = await this.$api.integrationManagement.types();

    const typeOptions = Object.keys(types).map((typeKey) => {
      return {
        value: typeKey,
        text: types[typeKey].label,
        image: types[typeKey].image,
        selectable: types[typeKey].selectable
      };
    });

    this.typeOptions = typeOptions;

    const dataString = localStorage.getItem("integrationData");

    if (this.code && dataString) {
      this.resetRdRegister();
    }

    EventBus.$on("RESE_INTEGRATION_FORM", this.reset);
  },

  beforeDestroy() {
    EventBus.$off("RESE_INTEGRATION_FORM", this.reset);
  },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.integration-form {
  position: relative;

  .integration-form-return {
    position: absolute;
    top: 12px;
    left: 10px;
    z-index: 100;
    color: $primary;

    i {
      font-size: 30px;
    }
  }

  &.card-body {
    min-height: 0 !important;

    .stepper {
      border: none;
      box-shadow: none;

      .stepper-header {
        padding: 0;
      }
    }

    .v-input {
      margin: 12px 0 10px 0;
    }

    button {
      display: block;
      margin: 0 auto;
    }
  }

  &.integration-form_edit {
    &.card-body {
      .stepper {
        .stepper-header {
          .stepper-header-step {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
